import React from 'react'
import { connect } from 'react-redux'

import { getDate, validatedDate } from '../../redux/helpers'
import { DropdownButton, MenuItem, Modal, Button } from 'react-bootstrap'

import API from 'redux/api/reports'

export const types = {
  GENERAL: 'general',
  DETAILED: 'detailed'
}

class Reports extends React.Component {
  state = {
    isSending: false,
    isSended: false,
    isShowModal: false,
    type: '',
    email: '',
    name: '',
    start: '',
    stop: '',
    sid: ''
  }

  handleClose = () => {
    this.setState({ isShowModal: false })
  }

  handleShow = (type) => {
    let sname = this.props.sites.find((value) => +value.id === +(this.props.statForm ? this.props.statForm.values.site_id : -1)) || ''

    this.setState({
      isShowModal: true,
      email: this.props.user.email || '',
      name: this.props.user.name || '',
      type,
      isSended: false,
      sid: this.props.statForm ? this.props.statForm.values.site_id : '',
      sname: sname ? sname.name : ''
    })
    this.setDates()
  }

  onChangeEmail = ($e) => this.setState({ email: $e.target.value })

  onSubmit = ($e) => {
    const {
      start,
      stop,
      email,
      type,
      sid
    } = this.state
    $e.preventDefault()

    this.setState({ isSending: true })
    API
      .send({
        start,
        stop,
        email,
        type,
        sid
      })
      .catch((error) => console.log('++ error send request report: ', error.message))
      .then(() => this.setState({ isSended: true }))
      .finally(() => this.setState({ isSending: false }))
  }

  setDates = () => {
    const { currentTab, dates } = this.props

    let startPre = +currentTab === 5 ? dates.start : getDate('start', currentTab)
    let stopPre = +currentTab === 5 ? dates.stop : getDate('end', currentTab)

    const start = validatedDate(startPre)
    const stop = validatedDate(stopPre)

    this.setState({
      start,
      stop
    })
  }

  render () {
    const {
      isShowModal,
      email,
      isSended,
      start,
      stop,
      isSending,
      type,
      name,
      sid,
      sname
    } = this.state

    return (
      <li role="presentation" className={`pull-right reports`}>
        <DropdownButton
          bsStyle={'success'}
          title={'Выгрузить отчет'}
          id={`reports-1`}
        >
          <MenuItem eventKey="1" onClick={() => this.handleShow(types.GENERAL)}>Общий отчет</MenuItem>
          <MenuItem eventKey="2" onClick={() => this.handleShow(types.DETAILED)}>Отчет с детализацией</MenuItem>
        </DropdownButton>

        <Modal
          show={isShowModal}
          onHide={this.handleClose}
          bsSize="small">
          <Modal.Header closeButton style={{ border: 'none' }}>
            {isSended && <div className="reports-sended">
              <p>{`${type === types.GENERAL ? 'Общий отчет' : 'Отчет с детализацией'}`} {sid ? `по сайту ${sname} издателя` : `по издателю`} {name} за
                период c {start} по {stop} был отправлен на почту {email}</p>
              <Button onClick={this.handleClose}>OK</Button>
            </div>}
            {!isSended && <div className="reports-email">Подтвердите e-mail для отправки отчета:
              <form onSubmit={this.onSubmit}>

                <div className="form-group" style={{ marginTop: '8px' }}>
                  <input
                    type="email"
                    className={'form-control'}
                    placeholder={'e-mail'}
                    onChange={this.onChangeEmail}
                    value={email}
                    required={true} />
                </div>
                <div style={{ display: 'flex' }}>
                  <Button
                    type={'submit'}
                    className={`${isSending ? 'disabled' : ''}`}
                    style={{
                      display: 'flex',
                      alignItems: 'center'
                    }}>
                    {isSending && <div className="spinner" style={{ marginRight: '4px' }}></div>}
                    {isSending && (
                      <span>Отправляем..</span>
                    )}
                    {!isSending && (
                      <span>Отправить</span>
                    )}
                  </Button>
                  <Button style={{ marginLeft: '8px' }} onClick={this.handleClose}>Закрыть</Button>
                </div>
              </form>
            </div>}
          </Modal.Header>
        </Modal>
      </li>
    )
  }
}

export default connect((
  {
    sites: { main: { list } },
    user: { data },
    main: { currentTab, dates },
    form: {
      statForm
    }
  }) => ({
  user: data,
  currentTab,
  dates,
  statForm: statForm,
  sites: list
}))(Reports)
